import { ArrowRight, FileText } from 'lucide-react'
import type { FollowUpAction } from '@/types/chat.types'
import styles from './FollowUpActions.module.css'

export interface FollowUpActionsProps {
  actions: FollowUpAction[]
  onActionClick: (action: FollowUpAction) => void
  disabled?: boolean
}

export function FollowUpActions({ actions, onActionClick, disabled = false }: FollowUpActionsProps) {
  if (actions.length === 0) {
    return null
  }

  const getIcon = (type: string) => {
    switch (type) {
      case 'chat_query':
        return <ArrowRight size={14} strokeWidth={2} />
      case 'copy_text':
        return <FileText size={14} strokeWidth={2} />
      default:
        return null
    }
  }

  return (
    <div className={styles['actionsWrapper']}>
      {/* Optional header label */}
      <div className={styles['actionsHeader']}>SUGGESTED NEXT STEPS</div>

      {/* Actions chips container */}
      <div className={styles['actionsChips']}>
        {actions.map((action) => (
          <button
            key={`${action.type}-${action.label}-${action.payload.substring(0, 20)}`}
            type="button"
            className={`${styles['actionChip'] ?? ''} ${disabled ? styles['actionChipDisabled'] ?? '' : ''}`}
            onClick={() => {
              if (!disabled) {
                onActionClick(action)
              }
            }}
            disabled={disabled}
            title={action.label} // Full text in tooltip
          >
            <span className={styles['actionIcon'] ?? ''}>{getIcon(action.type)}</span>
            <span className={styles['actionLabel'] ?? ''}>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
